import script from "./DrawEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawEditor.vue?vue&type=script&setup=true&lang=ts"

import "./DrawEditor.vue?vue&type=style&index=0&id=af089558&lang=css"

const __exports__ = script;

export default __exports__